var map = {
	"./L-bottom.svg": 26482,
	"./L-top.svg": 41704,
	"./accept-mark-black.svg": 11070,
	"./accept-mark-green.svg": 99974,
	"./accept-mark.svg": 96580,
	"./add-contact-small-black.svg": 38756,
	"./add-contact.svg": 74468,
	"./add-group.svg": 47897,
	"./add-list.svg": 36672,
	"./add-red.svg": 52237,
	"./add-user-to-favorite.svg": 45230,
	"./additional-arrow.svg": 70717,
	"./arrow-down-left-and-arrow-up-right-to-center.svg": 68243,
	"./arrows-from-dotted-line-solid.svg": 27159,
	"./attachment-red.svg": 29395,
	"./attachment.svg": 41265,
	"./automatyczne_konczenie.svg": 23729,
	"./automatyczne_przejscie.svg": 93908,
	"./automatyczne_uruchomienie.svg": 97740,
	"./bin.svg": 27313,
	"./bold-icon.svg": 4415,
	"./bold.svg": 40315,
	"./bolt-solid.svg": 41385,
	"./bolt.svg": 45643,
	"./book.svg": 82905,
	"./break-time-icon.svg": 89767,
	"./bullet-list.svg": 8363,
	"./calenda-chevron-right.svg": 42849,
	"./calendar-chevron-left.svg": 99912,
	"./calendar-chevron-right.svg": 47895,
	"./calendr-chevron-left.svg": 59951,
	"./callendar.svg": 27648,
	"./clock.svg": 85896,
	"./close-alert.svg": 11867,
	"./copy.svg": 21385,
	"./cube.svg": 98769,
	"./delete-point.svg": 93638,
	"./delete.svg": 56683,
	"./download-black.svg": 3096,
	"./download-color.svg": 62252,
	"./download.svg": 4026,
	"./edit.svg": 25414,
	"./error-alert.svg": 75017,
	"./exit-btn.svg": 84513,
	"./exit-red.svg": 49176,
	"./exit.svg": 42138,
	"./eye.svg": 45373,
	"./eye2.svg": 56021,
	"./file-check.svg": 75491,
	"./file-exclamation.svg": 88952,
	"./file-zipper-light.svg": 72916,
	"./file.svg": 46224,
	"./filter.svg": 98512,
	"./gear-complex.svg": 61528,
	"./go-back-arrow-small.svg": 31618,
	"./go-back-arrow.svg": 53248,
	"./hand.svg": 2681,
	"./header-1.svg": 24519,
	"./header-2.svg": 36660,
	"./hourglass-end.svg": 73612,
	"./hourglass.svg": 43208,
	"./import-from-db.svg": 33413,
	"./inbox-in.svg": 96894,
	"./info.svg": 24930,
	"./italic.svg": 150,
	"./lock.svg": 18939,
	"./maximize.svg": 80420,
	"./message.svg": 7151,
	"./microphone-lines.svg": 50212,
	"./microphone-slash.svg": 15902,
	"./microphone.svg": 78574,
	"./minimize.svg": 63650,
	"./nfc-signal.svg": 88894,
	"./note.svg": 27918,
	"./notice-alert.svg": 42575,
	"./ordered-list.svg": 45006,
	"./paper-plane-top.svg": 99059,
	"./paper-plane.svg": 25253,
	"./pen.svg": 98843,
	"./play.svg": 12456,
	"./plus-small.svg": 7436,
	"./posiedzenia.svg": 35395,
	"./presentation-screen.svg": 75523,
	"./qrcode.svg": 8036,
	"./redo.svg": 26162,
	"./refresh-list.svg": 3512,
	"./remove-user-favorite.svg": 87703,
	"./save.svg": 70097,
	"./search.svg": 15378,
	"./select-arrow.svg": 4318,
	"./send-mail-white.svg": 47244,
	"./send-mail.svg": 14140,
	"./send-sms-white.svg": 74908,
	"./send-sms.svg": 7148,
	"./share-from-square-light.svg": 22539,
	"./share-from-square.svg": 92224,
	"./speaker-white.svg": 4121,
	"./speaker.svg": 15877,
	"./star-empty.svg": 20553,
	"./star.svg": 21698,
	"./stop.svg": 69562,
	"./strike.svg": 69388,
	"./success-alert.svg": 37182,
	"./tooltip.svg": 47015,
	"./triangle-exclamation.svg": 59414,
	"./ukryj_wyniki_w_trakcie.svg": 1431,
	"./undo.svg": 96836,
	"./up-right-and-down-left-from-center.svg": 22404,
	"./upload-attachment -color.svg": 6069,
	"./upload-attachment.svg": 22109,
	"./user-check-presence.svg": 35126,
	"./user-check-quorum.svg": 38106,
	"./user-minus.svg": 29332,
	"./user-slash.svg": 44783,
	"./users-medical.svg": 51880,
	"./voting-add.svg": 4257,
	"./voting-edit-white.svg": 34372,
	"./voting-edit.svg": 6020,
	"./voting-lock.svg": 70549,
	"./voting.svg": 63335,
	"./xmark.svg": 3777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20258;